import { coordForGame } from '../../core/game-adapter.js';

export function renderCaroPosition(boardEl, board, {
  flipped = false,
  lastMove = null,
  winningLine = [],
  onClick = () => {}
} = {}) {
  boardEl.innerHTML = '';
  const winning = new Set(winningLine || []);
  const order = [...Array(board.length).keys()];
  if (flipped) order.reverse();

  for (const idx of order) {
    const square = document.createElement('button');
    square.type = 'button';
    square.className = 'caro-cell';
    square.dataset.idx = String(idx);
    square.setAttribute('role', 'gridcell');

    const piece = board[idx];
    square.setAttribute(
      'aria-label',
      coordForGame('caro', idx) + (piece ? ' · ' + piece : ' · trống')
    );

    if (lastMove?.to === idx) square.classList.add('last');
    if (winning.has(idx)) square.classList.add('winning');

    if (piece) {
      const stone = document.createElement('span');
      stone.className = 'caro-stone ' + (piece === 'X' ? 'x' : 'o');
      stone.textContent = piece;
      square.appendChild(stone);
    }

    square.addEventListener('click', () => onClick(idx));
    boardEl.appendChild(square);
  }
}

export function renderCaroBoard(boardEl, game, {
  flipped = false,
  onClick = () => {}
} = {}) {
  const status = game.status();
  renderCaroPosition(boardEl, game.board, {
    flipped,
    lastMove: game.history.at(-1)?.move || null,
    winningLine: status.winningLine,
    onClick
  });
  return status;
}
